/**
 * This file is generated automatically by using npm run build:translation
 */

export const TRANSLATION_HASHES: Record<string, string> = {
  "en": "7be764777a3b009aae1d650a795401ee",
  "fr": "832c8bf7ed00c02db96250dd3671d96a"
};
